const COOKIE_CONSENT_KEY = 'bypass_cookie_consent';

export function hasCookieConsent() {
    try {
        return localStorage.getItem(COOKIE_CONSENT_KEY) === '1';
    } catch {
        return false;
    }
}

export function acceptCookieConsent() {
    try {
        localStorage.setItem(COOKIE_CONSENT_KEY, '1');
    } catch {
        // storage unavailable — banner still closes via local state
    }
}
